import React, { useState } from "react";
import { updateTravelDocs } from "../../utils/requestHandler";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const UpdateTravelDocs = ({
  setShowTravelDocsModal,
  document_details,
  guest_info,
  fetchBookingValidation,
}) => {
  const bookingDetails = useSelector((state) => state.bookingValidation.data);
  const formatDate = (date) => {
    const d = new Date(date);
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const day = ("0" + d.getDate()).slice(-2);
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  };
  const [documentDetails, setDocumentDetails] = useState({
    document_type: document_details.document_type || "Passport - US",
    document_name: document_details.document_name,
    document_id: document_details.document_id,
    document_expiry_date: document_details.expiry_date
      ? formatDate(document_details.expiry_date)
      : "",
    guest_id: guest_info.id,
    booking_id: bookingDetails.booking_id,
  });

  const parseDate = (date) => {
    const [month, day, year] = date.split("/");
    return month + "/" + day + "/" + year;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDocumentDetails({
      ...documentDetails,
      [name]: value,
    });
  };

  const handleSave = () => {
    if (
      documentDetails.document_expiry_date &&
      new Date(documentDetails.document_expiry_date) < new Date()
    ) {
      toast.error("Document expiry date should be greater than current date.");
      return;
    }
    const updatedDetails = {
      ...documentDetails,
      document_expiry_date: documentDetails.document_expiry_date
        ? parseDate(documentDetails.document_expiry_date)
        : null,
    };
    updateTravelDocs(updatedDetails)
      .then((result) => {
        toast.success("Travel documents updated successfully.");
        setShowTravelDocsModal(false);
        fetchBookingValidation();
      })
      .catch((error) => {
        toast.error("An error occurred while updating travel documents.");
        console.log("error", error);
      });
  };

  return (
    <div>
      <div className="w-full max-w-lg mx-auto mt-10 p-6 relative bg-white shadow-md rounded-md">
        <div className="flex absolute right-2 top-2 justify-end">
          <div
            onClick={() => setShowTravelDocsModal(false)}
            className="cursor-pointer text-4xl"
          >
            &times;
          </div>
        </div>
        <div className="-m-6 p-6 mb-0 flex flex-col justify-center pb-0 bg-mv-lightblue">
          <div className="flex gap-5 text-mv-darkblue items-center">
            <h1 className="text-2xl uppercase font-bold mb-4">
              {guest_info.first_name + " " + guest_info.last_name}
            </h1>
            <p className="mb-2">D.O.B: {guest_info?.dob}</p>
          </div>
          <p className="text-gray-600 mb-4">
            For name and date of birth edits, please reach out to our customer
            service team for assistance.{" "}
            <Link to="#" className="text-mv-darkblue underline">
              Contact customer service
            </Link>
          </p>
        </div>
        <h1 className="text-mv-darkblue uppercase font-semibold py-2 text-xl">
          Travel Documents
        </h1>
        <form>
          <div className="mb-4">
            <label
              className="block text-mv-darkblue font-semibold mb-1"
              htmlFor="document_type"
            >
              Document Type
            </label>
            <select
              id="document_type"
              name="document_type"
              className="w-full px-3 py-2 border rounded-md"
              value={documentDetails.document_type || "Passport - US"}
              onChange={handleChange}
            >
              <option value="Passport - US">Passport - US</option>
              <option value="Passport - Other">Passport - Other</option>
              <option value="Birth Certificate">Birth Certificate</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <div className="mb-4">
            <label
              className="block text-mv-darkblue font-semibold mb-1"
              htmlFor="document_name"
            >
              Name on Document
            </label>
            <input
              type="text"
              id="document_name"
              name="document_name"
              className="w-full px-3 py-2 border rounded-md"
              placeholder="Name on Document"
              value={documentDetails.document_name}
              onChange={handleChange}
            />
          </div>
          {documentDetails.document_type !== "Birth Certificate" && (
            <>
              {" "}
              <div className="mb-4">
                <label
                  className="block text-mv-darkblue font-semibold mb-1"
                  htmlFor="document_id"
                >
                  Document Number
                </label>
                <input
                  type="text"
                  id="document_id"
                  name="document_id"
                  className="w-full px-3 py-2 border rounded-md"
                  placeholder="Document Number"
                  value={documentDetails.document_id}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-4">
                <label
                  className="block text-mv-darkblue font-semibold mb-1"
                  htmlFor="document_expiry_date"
                >
                  Document Expiration Date
                </label>
                <input
                  type="text"
                  placeholder="MM/DD/YYYY"
                  id="document_expiry_date"
                  name="document_expiry_date"
                  className="w-full px-3 py-2 border rounded-md"
                  value={documentDetails.document_expiry_date}
                  onChange={handleChange}
                />
              </div>
            </>
          )}
        </form>
        <div className="flex py-4 justify-end">
          <button
            onClick={handleSave}
            type="submit"
            className="bg-mv-darkblue text-white px-4 py-2 rounded-md"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateTravelDocs;
